// This file contains all validation schemas
import { object, string, mixed } from 'yup';

const creditCardMetaSchema = object({
  id: string().required('Card id required'),
  brand: string().optional(),
  last4: string().optional(),
  exp_month: string().optional(),
  exp_year: string().optional(),
}).noUnknown(false);

const creditCardValidation = object().shape({
  value: string().required('Payment method is required'),
  name: string(),
  content: mixed(),
  metaData: creditCardMetaSchema.required('Meta data is required'),
});

const rechargeAmountValidation = string()
  .required('Recharge amount is required')
  .test('is-valid-amount', 'Amount must be at least 1', (value) => {
    const num = Number.parseFloat(value || '0');
    return !Number.isNaN(num) && num >= 1;
  });

export const rechargeValidationSchema = object().shape({
  rechargeAmount: rechargeAmountValidation,
  creditCard: creditCardValidation,
});

export const autoRechargeValidationSchema = object().shape({
  balanceThreshold: string()
    .required('Balance threshold is required')
    .test('is-valid-threshold', 'Threshold must be at least 1', (value) => {
      const num = Number.parseFloat(value || '0');
      return !Number.isNaN(num) && num >= 1;
    }),
  rechargeAmount: rechargeAmountValidation.test(
    'recharge>=threshold',
    'Recharge amount must be greater than or equal to threshold',
    function validateRechargeThreshold(value) {
      const { balanceThreshold } = this.parent;
      if (value === undefined || balanceThreshold === undefined) return true;
      return Number(value) >= Number(balanceThreshold);
    },
  ),
  creditCard: creditCardValidation,
});
